export default {"src":"/_next/static/media/blue-options.71323680.svg","height":25,"width":134,"blurWidth":0,"blurHeight":0};